import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import {TextField} from '@material-ui/core'

//import theme from '../theme';

import DateFnsUtils from '@date-io/date-fns';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import { isInteger, isNumber } from '../api/validators';


export class CustomField_ extends React.Component{

    constructor(props){
        super(props)

        this.state={
            changed: false,
            value: props.value,
            error: false    
        }

        this.handleInput = this.handleInput.bind(this)
        this.handleDateChange = this.handleDateChange.bind(this) 
    }


    handleInput(event){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        
        let err = !this.validate(val)

        this.setState({value: val, ...changed})

        this.props.onChange(event, err)
    }

    handleDateChange(date){

        let changed = !this.state.changed ? {changed: true} : {}
        
        //console.log('handleDateChange')
        //console.log(date)

        this.setState({value: date, ...changed})

        let event = {target:{name:this.props.name, value:date, type:'date'}}
        this.props.onChange(event)
    }


    validate(value){
        //console.log('validate() '+this.props.type + ' ' +value)
        switch(this.props.type){
            case 'Int':
                let isInt = isInteger(value)
                if(!isInt){
                    let error = this.props.t('IsNotInteger')
                    this.setState({error: error})
                    return false
                }
                break

            case 'Float':
                let isNum = isNumber(value)
                //console.log('isNumber='+isNum.toString())
                if(!isNum){
                    let error = this.props.t('IsNotNumber')
                    this.setState({error: error})
                    return false
                }
                break

            default:
        }

        this.setState({error: false})
        return true
    }


    render() {
        const {t, i18n} = this.props

        switch(this.props.type){
            case 'Int':
            case 'Float':
            case 'String':{
                let val = this.state.value!==null ? this.state.value : ''
                return (
                    <TextField name={this.props.name}  margin="normal"
                        style={{width: '100%'}}
                        label={this.state.error?this.state.error:this.props.label+' ('+this.props.type+')'}
                        autoComplete="new-password"
                        error={this.state.error!==false}
                        value={this.state.value}
                        onChange={this.handleInput}
                    />                    
                )
            }
                
            case 'Date':{
                let dateFormat
                switch(i18n.language){
                    case 'ru': dateFormat = "dd.MM.yyyy"; break

                    case 'en':
                    default: dateFormat = "MM/dd/yyyy"
                }
                
                //console.log('Date')
                //console.log(this.state.value)

                return (
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        style={{marginRight: 16}}
                        margin="normal"
                        name={this.props.name}
                        label={this.state.error?this.state.error:this.props.label}
                        cancelLabel={t('Cancel')}
                        okLabel={t('Apply')}
                        format={dateFormat}
                        value={this.state.value}
                        onChange={this.handleDateChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        />
                    </MuiPickersUtilsProvider>
                )
            }

            default:
                alert('Unsupported field type '+this.props.type)
                return ''

        }

    }

}

export const CustomField = withTranslation()(CustomField_);